// ---------------------------------------------------------------------------
// WebSocket client with auto-reconnect.
// ---------------------------------------------------------------------------

import type { Intent, ServerMsg } from "../shared/protocol";

export class Net {
  private ws: WebSocket | null = null;
  private retry = 0;
  private closed = false;
  connected = false;

  constructor(
    private room: string,
    private name: string,
    private pid: string,
    private setup: string | undefined,
    private onMsg: (m: ServerMsg) => void,
    private onStatus: (connected: boolean) => void,
  ) {
    this.connect();
  }

  private connect(): void {
    const proto = location.protocol === "https:" ? "wss:" : "ws:";
    let url = `${proto}//${location.host}/ws?room=${encodeURIComponent(this.room)}&name=${encodeURIComponent(this.name)}&pid=${encodeURIComponent(this.pid)}`;
    if (this.setup) url += `&setup=${encodeURIComponent(this.setup)}`;
    const ws = new WebSocket(url);
    this.ws = ws;
    ws.onopen = () => {
      this.retry = 0;
      this.connected = true;
      this.onStatus(true);
    };
    ws.onmessage = (ev) => {
      try {
        this.onMsg(JSON.parse(ev.data as string) as ServerMsg);
      } catch (e) {
        console.error("bad server message", e);
      }
    };
    ws.onclose = () => {
      this.connected = false;
      this.onStatus(false);
      if (this.closed) return;
      const delay = Math.min(5000, 300 * 2 ** this.retry++);
      setTimeout(() => this.connect(), delay);
    };
    ws.onerror = () => ws.close();
  }

  send(intent: Intent): void {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(intent));
    }
  }

  close(): void {
    this.closed = true;
    this.ws?.close();
  }
}
